export default __webpack_public_path__ + "static/flower-f863299937c4e81e9416fe6a557787b8.mp4";